<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <div class="demo-form-inline">
          <!-- <el-form-item label="编号/设备ID:">
            <el-input v-model="formInline.user" placeholder="请输入"></el-input>
          </el-form-item>-->
          <el-form-item label="选择门店">
            <el-select v-model="formInline.id" placeholder="请选择" @change="getlist">
              <el-option
                v-for="index in typeDate"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.id"
              ></el-option>
            </el-select>
            <!-- <el-form-item style="min-width: 150px; margin-left: 20px;">
              <el-button type="primary" style="background: #1890ff;" @click="onSubmit">查询</el-button>
              <el-button type="primary" class="vubutton" @click="onSubmit">重置</el-button>
            </el-form-item>-->
          </el-form-item>
        </div>
        <div class="bottom_center">
          <el-button
            type="primary"
            class="vubutton"
            :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
            @click="onSubmit"
          >+新建</el-button>
        </div>
      </el-form>

      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto;"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备类型" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.device_type }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备编号" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column label="容量" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.volume }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at }}</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.enable&&'启用'||'停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" @click="getEdit(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <!-- /// -->
    <el-dialog title="餐炉信息" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="餐炉名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="设备编号" :label-width="formLabelWidth">
          <el-input v-model="form.code" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" :label-width="formLabelWidth" :disabled="form.getEdit">
          <el-select
              v-model="form.device_type"
              placeholder="请选择"
              :disabled="form.getEdit"
          >
            <el-option
                v-for="index in deviceTypes"
                v-bind:key="index.id"
                :label="index.dtype_value"
                :value="index.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="容量" :label-width="formLabelWidth">
          <el-select
            v-model="form.volume"
            placeholder="请选择"
            :disabled="form.getEdit"
          >
            <el-option
              v-for="index in postTionsList"
              v-bind:key="index.id"
              :label="index.value"
              :value="index.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" v-if="putStatus" :label-width="formLabelWidth">
          <el-select v-model="form.enable" placeholder="请选择活动区域" :disabled="form.getEdit">
            <el-option label="启用" :value="true"></el-option>
            <el-option label="停用" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" :label-width="formLabelWidth" v-if="form.getEdit">
          <el-input v-model="form.created_at" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" :label-width="formLabelWidth" v-if="form.getEdit">
          <el-input v-model="form.updated_at" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus()">取 消</el-button>
        <el-button type="primary" @click="statusStore()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';

export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        user: '',
        id: '',
      },
      tableData: [],
      typeDate: [],
      total: 0,
      page_no: 0,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      form: {
        name: '',
        code: '',
        volume: 0,
        device_type: ''
      },
      putStatus: false,
      postTionsList:[],
      deviceTypes:[],
    };
  },
  methods: {
    pageSize(index) {
      this.page_no = index;
      this.getlist();
    },
    onSubmit() {
      this.dialogFormVisible = true;
      this.putStatus = false;
      this.setForm();
    },
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.putStatus = true;
      this.form = row;
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm('此操作将删除餐炉, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const url = this.$userList.user_device_set + '/' + row.id;
        this.$http.delete(url).then(res => {
          if (res.code === 200) {
            this.getlist();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除餐炉失败');
          }
        });
      });
    },
    getlist() {
      const url =
        this.$userList.user_device_list +
        `/${this.page_no}/10?shopId=${this.formInline.id}`;
      // const url =
      //   this.$userList.user_device_list +
      //   `/${this.page_no}/20?shopId=25884083765760`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          console.log(res.data.count, '?????');
          this.total = res.data.count;
          this.tableData = res.data.items.map(item => {
            item.created_at = fecha.format(
              new Date(item.created_at),
              'yyyy-MM-dd HH:mm:ss'
            );
            item.updated_at = fecha.format(
              new Date(item.updated_at),
              'yyyy-MM-dd HH:mm:ss'
            );
            return item;
          });
        } else {
          //res.message && this.$alert(res.message);
        }
      });
    },
    getType() {
      this.listloading = true;
      const url = this.$userList.user_restaurant_list + `/${this.page_no}/999`;
      this.$http.get(url).then(res => {
        this.listloading = false;
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.getlist();
          this.getPositions();
        } else {
          //res.message && this.$alert(res.message);
        }
      });
    },
    setStore() {
      const url =this.$userList.user_device_set + '/new?shopId=' + this.formInline.id;
      this.$http.post(url, this.form).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getlist();
          return;
        }
        if (res.code !== 200) {
          this.$alert('新增餐炉失败');
        }
        console.log(res);
      });
    },
    putDtore() {
      const data = {
        id: this.form.id,
        name: this.form.name,
        code: this.form.code,
        enable: this.form.enable,
        volume: this.form.volume,
        device_type: this.form.device_type
      };
      const url =
        this.$userList.user_device_set
      this.$http.put(url, data).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getlist();
          return;
        }
        if (res.code !== 200) {
          this.$alert('修改餐炉失败');
        }
      });
    },
    statusStore() {
      if (this.form.getEdit) {
        this.dialogFormVisible = false;
        return;
      }
      if (!this.putStatus) {
        this.setStore();
      } else {
        this.putDtore();
      }
    },
    noStatus() {
      this.dialogFormVisible = false;
      if (this.form.getEdit || !this.putStatus) {
        return;
      }
      this.getlist();
    },
    setForm() {
      this.form = {
        name: '',
        code: '',
      };
    },
    getEdit(index, row) {
      // this.putStatus = true;
      const url = this.$userList.user_device_set + '/' + row.id;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          res.data.getEdit = true;
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          this.form = res.data;
          this.dialogFormVisible = true;
          this.putStatus = true;
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取详细信息失败');
        }
      });
      console.log(index, row);
    },
    getPositions() {
      const url = this.$userList.user_common_data + `/volume`;
      const url2 = this.$userList.user_common_data + `/device_type`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          console.log(res, '????xxxxxx');
          this.postTionsList=res.data
        } else {
          res.message && this.$alert(res.message);
        }
      });
      this.$http.get(url2).then(res => {
        if (res.code === 200) {
          console.log(res, '????xxxxxx');
          this.deviceTypes=res.data
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
  },

  created() {
    this.getType();
    this.$root.setheadName();
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}
.top_div {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}
.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}
/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}
.el-button--primary:hover,
.el-button--primary:active,
.el-button--primary:focus {
  background: #1890ff;
  border-color: #1890ff;
}
.el-table--group::after,
.el-table--border::after,
.el-table::before {
  background: none;
}
.el-form--inline .el-form-item {
  margin-right: 50px;
}
.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.el-table__empty-block {
  width: none !important;
}
.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
